export const generalRegex = {
  dateFormat: {
    'DD-MM-YYYY': /^\d{2}-\d{2}-\d{4}$/,
    'DD.MM.YYYY': /^\d{2}\.\d{2}\.\d{4}$/,
    'YYYY.MM.DD': /^\d{4}\.\d{2}\.\d{2}$/,
    'YYYY.MM.DD.': /^\d{4}\.\d{2}\.\d{2}\.$/,
    'MM-DD-YYYY': /^\d{2}-\d{2}-\d{4}$/,
    'YYYY-MM-DD': /^\d{4}-\d{2}-\d{2}$/,
    YYYYMMDD: /^\d{8}$/,
    YYYYMMDDXXXX: /^\d{12}$/,
    'MM-YYYY': /^\d{2}-\d{4}$/,
    'MM.YYYY': /^\d{2}.\d{4}$/,
    'YYYY-MM': /^\d{4}-\d{2}$/,
    'YYYY.MM.': /^\d{4}.\d{2}.$/
  }
};
